import React from "react";
import "./skeleton.scss";

const Skeleton = () => (
  <div className="skeleton" data-testid="onboarding-skeleton">
    <div className="onboarding-wrapper">
      <div className="onboarding">
        <div className="step">
          <div className="box-placeholder">
            <div className="box-placeholder__main-content">
              <div className="hero-image-placeholder image" />
              <hr className="no-border" />
              <div className="button" />
              <div className="selling-points">
                <div className="point" />
                <div className="point" />
                <div className="point" />
                <div className="point" />
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="guidance" />
    </div>
  </div>
);

export default Skeleton;
